import React, { useState } from "react";
import { Button, Checkbox, Modal } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getAllSubcontractor,
  createSubContractor,
  addCustomerToQuickBooks,
} from "../../webServices/Apis";
import { message } from "antd";
import TextArea from "antd/es/input/TextArea";
import Loader from "../Loader/Loader";
import { parseString } from "xml2js";

const AddSubContracter = ({
 
  showAddContracter,
  setShowAddContracter,
  action,
  setAction,
}) => {
  const [open, setOpen] = useState(showAddContracter);
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [isHstApplied, setIsHstApplied] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      lastName: "",
      emergencyContact: "",
      streetno: "",
      city: "",
      prov: "",
      code: "",
      homephone: "",
      ins: "",
      bus: "",
      hst: "",
      applyHst: "",
      hstrate: "",
      comment: "",
      email: "",
      phone: "",
      gender: "",
      companyName: "",
      profile: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("First name is required").max(30 , "Fist name should not be more than 30 characters").trim("First name should not have spaces").matches(/^[a-zA-Z]+$/, "First name should contains only letters also not spaces"),
      email: Yup.string().email("Invalid email").required("Email is required").matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address"
      ),
      lastName: Yup.string().required("Last name is required").max(30 , "Last name should not be more than 30 characters").trim("Last name should not have spaces").matches(/^[a-zA-Z]+$/, "Last name should contains only letters also not spaces"),
      //profile: Yup.string().required("Profile Image is required"),
      phone: Yup.string()
  .required("Phone number is required")
  .matches(/^(?!-)(?!.*--)(\d-?){5,14}\d$/, "Phone number must be between 6 and 15 digits"),
      // domain: Yup.string().required("Domain is required"),
      homephone: Yup.string().matches(/^(?!-)(?!.*--)(\d-?){5,14}\d$/, "Home phone number must be between 6 and 15 digits"),
      emergencyContact: Yup.string().matches(/^(?!-)(?!.*--)(\d-?){5,14}\d$/, "Emergency phone number must be between 6 and 15 digits"),
      comment: Yup.string().max(200 , "Comment cannot be more than 200 characters")
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setLoading(true);
        const formData = new FormData();

        // Dynamically append fields to formData only if they have values
        if (values.name) formData.append("firstName", values.name);
        if (values.lastName) formData.append("lastName", values.lastName);
        if (values.email) formData.append("email", values.email);
        if (values.emergencyContact)
          formData.append("emergencyPhone", values.emergencyContact);
        if (values.city) formData.append("city", values.city);
        if (values.streetno) formData.append("street", values.streetno);
        if (values.prov) formData.append("prov", values.prov);
        if (values.code) formData.append("code", values.code);
        if (values.homephone) formData.append("homePhone", values.homephone);
        if (values.ins) formData.append("ins", values.ins);
        if (values.bus) formData.append("bus", values.bus);

        // Check if HST is applied before adding HST rate
        formData.append("applyHst", isHstApplied ? true : false);
        if (isHstApplied) {
          formData.append("hst", values.hst);
        }
        if (values.hstrate) formData.append("hstRate", values.hstrate);

        if (values.comment) formData.append("comment", values.comment);
        if (values.phone) formData.append("phone", values.phone);
        // if (values.domain) formData.append("domain", values.domain);
        if (values.profile) formData.append("profileImage", values.profile);
        if (values.companyName) formData.append("companyName", values.companyName);

        const quickBooksData = {
          DisplayName: `${values.name} ${values.lastName}`,
          GivenName: values.name,
          FamilyName: values.companyName,
          PrimaryEmailAddr: {
            Address: values.email,
          },
          BillAddr: {
            Line1: values.streetno,
            City: values.city,
            CountrySubDivisionCode: values.prov,
            PostalCode: values.code,
          },
        };
       
       if (localStorage.getItem("access_token")){
          // Send the data to QuickBooks
       const qbResponse =  await addCustomerToQuickBooks(quickBooksData);

      if (qbResponse.status !== 200){
        message.error("Error while adding customer on Quickbooks");
        return ;
      }
      
       }
        const response = await createSubContractor(formData);

        if (response?.data?.success) {
          message.success(response.data.message);
         
          resetForm();
          setOpen(false);
          setShowAddContracter(false);
          setAction(!action);
        }
      } catch (error) {
       
        console.log("Error while creating sub contractor: ", error);

       

        if (error?.response?.status === 401){
          message.error("Session Timeout !");
          localStorage.clear()
          window.location.href="/login";
          return ;
        }


        if(error?.response?.status === 413){
          message.error("File size is too large")
          return;
        } 

        message.error(
          error.response.data.message ||
          "Error while creating sub contractor"
        );

        const xmlStringData = error?.response?.data


        if (xmlStringData && xmlStringData.includes("<?xml")) {
          const xmlString = xmlStringData.slice("Error creating customer: ".length);
          parseString(xmlString, (err, result) => {
            if (err){
              console.log("Error while converting data")
              return
            }
            const qbError = result?.IntuitResponse?.Fault[0]?.Error[0]?.Detail[0]
            const showError = qbError.replace(". : null", " on your quick-books account")
            message.error(showError)
          })
          return ;
        }
        
      
    }finally {
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  const handleProfileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
      formik.setFieldValue("profile", file);
    }
  };

  const handleRemoveImage = () => {
    setProfileImage(null);
    formik.setFieldValue("profile", null);
  };

  const closeCreateModal = () => {
    setOpen(false);
    setShowAddContracter(false);
  };

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white  rounded-2xl shadow-lg w-[900px] h-[600px] overflow-y-auto scrollbar-hidden">
          {loading && <Loader />}
          <h3 className="text-xl font-bold mb-1 text-center bg-blue-950 py-2 text-white">
            Create Sub Contractor
          </h3>
          <form onSubmit={formik.handleSubmit} className="p-8">
            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mb-2 py-1">
              Personal Details
            </h1>
            <div className="flex gap-2 ">
              <div className="w-full">
                <label className="block mb-1">First Name:</label>
                <input
                  type="text"
                  name="name"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                  <p className="text-red-600">{formik.errors.name}</p>
                )}
              </div>

              <div className="w-full">
                <label className="block mb-1">Last Name:</label>
                <input
                  type="text"
                  name="lastName"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                  <p className="text-red-600">{formik.errors.lastName}</p>
                )}
              </div>
            </div>
            <div className="flex gap-2 mt-2">
            <div className="w-full">
              <label className="block mb-1 mt-2">Email:</label>
              <input
                type="email"
                name="email"
                className="border border-gray-800 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email && (
                <p className="text-red-600">{formik.errors.email}</p>
              )}
            </div>
            <div className="w-full">
              <label className="block mb-1 mt-2">Company Name:</label>
              <input
                type="text"
                name="companyName"
                className="border border-gray-800 p-2 w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.companyName}
              />
              {/* {formik.touched.companyName && formik.errors.email && (
                <p className="text-red-600">{formik.errors.email}</p>
              )} */}
            </div>
            </div>
            <div className="flex gap-2 mt-2">
              <div className="w-full">
                <label className="block mb-1">Phone:</label>
                <input
                  type="text"
                  name="phone"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                />
                {formik.touched.phone && formik.errors.phone && (
                  <p className="text-red-600">{formik.errors.phone}</p>
                )}
              </div>

              <div className="w-full">
                <label className="block mb-1">Emergency Contact:</label>
                <input
                  type="text"
                  name="emergencyContact"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.emergencyContact}
                />
                {formik.touched.emergencyContact &&
                  formik.errors.emergencyContact && (
                    <p className="text-red-600">
                      {formik.errors.emergencyContact}
                    </p>
                  )}
              </div>
            </div>
            <div className="flex gap-2 mt-2">
              {/* <div className="w-full">
                {domains.length > 0 && (
                  <div className="mb-4">
                    <label className="block mb-1">Domain:</label>
                    <select
                      name="domain"
                      className="border p-2 w-full"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.domain}
                    >
                      <option value="">Select Domain</option>
                      {domains.map((each) => (
                        <option key={each.id} value={each.domainName}>
                          {each.domainName}
                        </option>
                      ))}
                    </select>
                    {formik.touched.domain && formik.errors.domain && (
                      <p className="text-red-600">{formik.errors.domain}</p>
                    )}
                  </div>
                )}
              </div> */}

              <div className="w-full">
                <label className="block mb-1">Profile Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleProfileChange}
                  className="cursor-pointer"
                />

                {formik.touched.profile && formik.errors.profile && (
                  <p className="text-red-600">{formik.errors.profile}</p>
                )}
                {profileImage && (
                  <div className="flex items-center border border-gray-800">
                    <img
                      src={profileImage}
                      alt="Profile Preview"
                      className="border border-gray-800 w-16 h-16 object-cover rounded-full mr-2"
                    />
                    <Button
                      type="button"
                      className="bg-red-600 text-white cursor-pointer"
                      onClick={handleRemoveImage}
                    >
                      Remove Image
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-3 mb-2 py-1">
              Address Details
            </h1>

            <div className="flex gap-2 mt-2">
              <div className="w-full">
                <label className="block mb-1">Street No:</label>
                <input
                  type="text"
                  name="streetno"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.streetno}
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">City:</label>
                <input
                  type="text"
                  name="city"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Prov:</label>
                <input
                  type="text"
                  name="prov"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.prov}
                />
              </div>
            </div>
            <div className="flex gap-2 mt-2">
              <div className="w-full">
                <label className="block mb-1">Code:</label>
                <input
                  type="text"
                  name="code"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.code}
                />
              </div>
              <div className="w-full">
                <label className="block mb-1">Home Phone:</label>
                <input
                  type="text"
                  name="homephone"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.homephone}
                />
                {formik.touched.homephone && formik.errors.homephone && (
                  <p className="text-red-600">{formik.errors.homephone}</p>
                )}
              </div>
            </div>

            <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-4 mb-2 py-1">
              Other Details
            </h1>
            <div className="flex gap-2 mt-2">
              <div className="w-full">
                <label className="block mb-1">Ins. #:</label>
                <input
                  type="text"
                  name="ins"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ins}
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Bus. #:</label>
                <input
                  type="text"
                  name="bus"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bus}
                />
              </div>
            </div>
            <div className="flex gap-2 mt-2">
              <div className="w-full mt-4">
                <div className="flex items-center gap-2">
                  <label className="block mb-1">Apply HST #:</label>
                  <Checkbox
                    checked={isHstApplied}
                    onChange={(e) => {
                      setIsHstApplied(e.target.checked);
                      if (!e.target.checked) {
                        formik.setFieldValue("hst", ""); // Clear the HST input if unchecked
                      }
                    }}
                  />
                </div>
                <input
                  type="text"
                  name="hst"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hst}
                  disabled={!isHstApplied} // Disable input if checkbox is not checked
                />
              </div>

              <div className="w-full mt-4">
                <label className="block mb-1">HST Rate:</label>
                <input
                  type="text"
                  name="hstrate"
                  className="border border-gray-800 p-2 w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.hstrate}
                  disabled={!isHstApplied}
                />
              </div>
            </div>

            <div className="w-full col-span-3 mt-2">
              <label className="block mb-1">Comment:</label>
              <textarea
                rows={4}
                name="comment"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.comment}
                placeholder="Enter your comments"
                className="border border-gray-800 p-2 w-full"
              />
              {formik.touched.comment && formik.errors.comment && (
                  <p className="text-red-600">{formik.errors.comment}</p>
                )}
            </div>
            <div className="flex justify-center gap-6 mt-6">
              <button
                onClick={closeCreateModal}
                className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
              >
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSubContracter;
